import { types } from 'mobx-state-tree'

export const UserModel = types.model('UserModel', {
  id: types.identifierNumber,
  userName: types.maybeNull(types.string),
  firstName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  emailAddress: types.maybeNull(types.string),
  phoneNumber: types.maybeNull(types.string),
  identityNumber: types.maybeNull(types.string),
  roleId: types.maybeNull(types.number),
  approvalLevel: types.maybeNull(types.number),
  canApprove: types.maybeNull(types.boolean),
  isNotAssigned: types.maybeNull(types.boolean),
  createdUtc: types.maybeNull(types.string),
  branchId: types.maybeNull(types.number),
  officeId: types.maybeNull(types.number),
  bankId: types.maybeNull(types.number),
  additionalPhoneNumber: types.maybeNull(types.string),
  isFirstTimePasswordWord: types.maybeNull(types.string),
})
